<template>
  <!-- 复制到 -->
  <div
    v-if="false"
    aria-labelledby="myModalLabel"
    class="modal fade"
    id="copy2"
    role="dialog"
    tabindex="-1"
  >
    <div class="modal-dialog" role="document">
      <div class="modal-content">
        <div class="modal-header">
          <button
            aria-label="Close"
            class="close"
            data-dismiss="modal"
            type="button"
          >
            <span aria-hidden="true">×</span>
          </button>
          <h4 class="modal-title" id="myModalLabel">复制到</h4>
        </div>
        <div class="modal-body">
          <div class="file-move">
            <div class id="treeview-copy2"></div>
          </div>
        </div>
        <div class="modal-footer">
          <button class="btn btn-default" data-dismiss="modal" type="button">
            取消
          </button>
          <button
            class="btn btn-primary"
            type="button"
            @click="copyToFolder"
            :disabled="isProcessing"
          >
            {{ isProcessing ? "正在复制..." : "确定" }}
          </button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Bus from "@/utils/bus";
export default {
  name: "TableCopySelected",
  data() {
    return {
      isProcessing: false,
    };
  },
  props: {
    selectedDatas: {
      type: Array,
    },
  },
  computed: {
    selectedFolder() {
      return this.$store.state.drive.selectedFolder;
    },
  },
  methods: {
    copyToFolder() {
      if (this.isProcessing) {
        return false;
      }
      this.isProcessing = true;
      if (!this.selectedFolder) {
        this.$message({
          type: "warning",
          message: "请选择目标文件夹",
        });
        this.isProcessing = false;
        return false;
      }
      let files_list = this.selectedDatas.map(function (item) {
        return {
          number: item.number,
          type: item.type,
        };
      });
      this.$store.commit("operationFileOrFolderData", {
        group_number: this.groupNumber,
        action: "copy",
        number: this.selectedFolder.number,
        disk_type: this.selectedFolder.disk_type,
        files_list: files_list,
      });
      this.$store
        .dispatch("copyToFolder")
        .then((res) => {
          if (res.status_code === 200) {
            this.isProcessing = false;
            $("#copy2").modal("hide");
            this.$message({
              type: "success",
              message: res.message,
            });
            if (res.entity.state === 2) {
              return false;
            }

            Bus.$on("jobSuccess", () => {
              this.$store.dispatch("getInfo");
            });
            this.$store.commit("addTask", {
              job_id: res.entity.job_id,
              job_type: "",
              run_percent: res.entity.run_percent,
              state: res.entity.state,
            });
            Bus.$emit("changeGlobalPluginStatus", {
              plugin: "showGlobalQueue",
              status: true,
            });
            // this.$emit("reloadInfo");
          } else {
            this.isProcessing = false;
            this.$message({
              type: "error",
              message: res.message,
            });
          }
        })
        .catch((err) => {
          this.isProcessing = false;
          this.$message({
            type: "error",
            message: err,
          });
        });
    },
  },
};
</script>

<style scoped>
</style>